import React, { useState } from "react";
import { useContext } from "react";
import Women from "../../../pictures/Women.png";
import { JwModal } from "./JwModal";
import { Link } from "react-router-dom";
import InsideMenu from "./InsideMenu";
import MenuIcon from "@material-ui/icons/Menu";
import { UserContext } from "../../UserContext";
function TopMenu() {
  const [mode, setMode] = useState("");
  const { value, setValue } = useContext(UserContext);
  return (
    <>
      <div
        onMouseDownCapture={JwModal.close("custom-modal-2")}
        className="top-menu"
      >
        <img src={Women} alt="Women's beauty" />

        <span onClick={JwModal.open("custom-modal-2")}>
          <b onClick={() => setMode("MAKE UP")}>MAKE UP</b>
        </span>

        <span onClick={JwModal.open("custom-modal-2")}>
          <b onClick={() => setMode("Hair")}> HAIR</b>
        </span>

        <span onClick={JwModal.open("custom-modal-2")}>
          <b onClick={() => setMode("BEAUTY MAGAZINE")}>BEAUTY MAGAZINE</b>
        </span>

        <span onClick={JwModal.open("custom-modal-2")}>
          <b onClick={() => setMode("Other Items")}>Other Items</b>
        </span>

        {value && (
          <Link to="/a">
            <div onClick={() => setValue(!value)} className="menu-icon">
              <MenuIcon />
            </div>
          </Link>
        )}
        {!value && (
          <Link to="/">
            <div onClick={() => setValue(!value)} className="menu-icon">
              <MenuIcon />
            </div>
          </Link>
        )}
        {console.log("value", value)}
      </div>

      <JwModal id="custom-modal-2">
        <InsideMenu mode={mode} />
      </JwModal>
    </>
  );
}

export default TopMenu;
